import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BannerSection from './components/BannerSection.vue';
import ExperienceSection from './components/ExperienceSection.vue';
import FooterSection from './components/FooterSection.vue';
import HabilitiesSection from './components/HabilitiesSection.vue';
import HeaderSection from './components/HeaderSection.vue'
import ResumeSection from './components/ResumeSection.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderSection),
    _createVNode(BannerSection),
    _createVNode(HabilitiesSection),
    _createVNode(ResumeSection),
    _createVNode(ExperienceSection),
    _createVNode(FooterSection)
  ], 64))
}
}

})